export default __webpack_public_path__ + "static/media/woman-box-4-clear.268b4bef.svg";